import {
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
} from "@mui/material";
import { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  ReportOwnerCategoryEnum,
  useHaveCustomPermissions,
} from "@ryde/shared";

import { radioButtonReportSx } from "./report-dialogs.styled";

interface ILoginTypeSwitchProps {
  name: string;
}

export const ReportOwnerCategorySwitch: FC<ILoginTypeSwitchProps> = ({
  name,
}) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const {
    hasPermissionCreateUserReports,
    hasPermissionCreateCompanyReports,
    hasPermissionCreateGlobalReports,
  } = useHaveCustomPermissions();

  const allOptions = new Set([
    ReportOwnerCategoryEnum.Global,
    ReportOwnerCategoryEnum.AllUsers,
    ReportOwnerCategoryEnum.UserOnly,
  ]);

  return (
    <div className="delete_report_button">
      <Controller
        rules={{ required: true }}
        control={control}
        name={name}
        render={({ field, fieldState: { error } }) => (
          <>
            <RadioGroup row {...field}>
              {allOptions?.has(ReportOwnerCategoryEnum.UserOnly) && (
                <FormControlLabel
                  value={ReportOwnerCategoryEnum.UserOnly}
                  control={<Radio onClick={e => e.stopPropagation()} />}
                  label={t(
                    `selectListLabel.${ReportOwnerCategoryEnum.UserOnly}`,
                  )}
                  sx={radioButtonReportSx}
                  disabled={!hasPermissionCreateUserReports}
                  onClick={e => e.preventDefault()}
                />
              )}
              {allOptions?.has(ReportOwnerCategoryEnum.AllUsers) && (
                <FormControlLabel
                  value={ReportOwnerCategoryEnum.AllUsers}
                  control={<Radio onClick={e => e.stopPropagation()} />}
                  label={t(
                    `selectListLabel.${ReportOwnerCategoryEnum.AllUsers}`,
                  )}
                  sx={radioButtonReportSx}
                  disabled={!hasPermissionCreateCompanyReports}
                  onClick={e => e.preventDefault()}
                />
              )}
              {allOptions?.has(ReportOwnerCategoryEnum.Global) && (
                <FormControlLabel
                  value={ReportOwnerCategoryEnum.Global}
                  control={<Radio onClick={e => e.stopPropagation()} />}
                  label={t(`selectListLabel.${ReportOwnerCategoryEnum.Global}`)}
                  sx={radioButtonReportSx}
                  disabled={!hasPermissionCreateGlobalReports}
                  onClick={e => e.preventDefault()}
                />
              )}
            </RadioGroup>
            {error && <FormHelperText>{error.message}</FormHelperText>}
          </>
        )}
      />
    </div>
  );
};
